<div class="discussion-sidebar">
  <!-- Login modal when user clicks Personalise items (My Discussions, My Bookmarks, Post Submission) but is not logged in -->
  <app-login-modal
    *ngIf="showLoginModal"
    [visible]="showLoginModal"
    (visibleChange)="showLoginModal = $event"
  ></app-login-modal>
  <!-- Categories Section -->
  <div class="discussion-sidebar--section">
    <div class="discussion-sidebar--section-header">
      <h3 class="discussion-sidebar--section-title">Categories</h3>
    </div>
    <div class="discussion-sidebar--menu">
      <button
        *ngFor="let item of categories"
        (click)="navigateToTab(item.tab)"
        class="discussion-sidebar--menu-item"
        [class.active]="isActive(item)"
        type="button"
      >
        <span class="discussion-sidebar--menu-label">{{ item.label }}</span>
      </button>
    </div>
  </div>

  <!-- Personalise Section -->
  <div class="discussion-sidebar--section">
    <div class="discussion-sidebar--section-header">
      <h3 class="discussion-sidebar--section-title">Personalise</h3>
    </div>
    <div class="discussion-sidebar--menu">
      <button
        *ngFor="let item of personalise"
        (click)="navigateToTab(item.tab)"
        class="discussion-sidebar--menu-item"
        [class.active]="isActive(item)"
        type="button"
      >
        <span class="discussion-sidebar--menu-label">{{ item.label }}</span>
      </button>
    </div>
  </div>
</div>
